module.exports = __webpack_public_path__ + "img/logo.8a97913.svg";